module.exports = "/images/punto_limpio.svg?bbdcce8c53978ca25886b0e956b6da59";